(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosController', PlanDeEstudiosController);

    PlanDeEstudiosController.$inject = ['PlanDeEstudios'];

    function PlanDeEstudiosController(PlanDeEstudios) {

        var vm = this;

        vm.planDeEstudios = [];

        loadAll();

        function loadAll() {
            PlanDeEstudios.query(function(result) {
                vm.planDeEstudios = result;
                vm.searchQuery = null;
            });
        }
    }
})();
